import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useCareerFilterStore = defineStore('careerFilter', () => {
  // Caregiver career enum keys; 'without_career' is the no-career bucket.
  const careers = ref<string[]>([]);

  function clear() {
    careers.value = [];
  }

  return { careers, clear };
}, { persist: true });
